import { LAYOUTS } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { closeModal, goBack, handleCloseOtpModal, resendOtp, verifyNewNumber, verifyOtp } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
export const template = (height, contactUsDetails) => {
    return {
        layout: {
            id: ROUTE.UPDATE_LOGIN_SCREEN,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'updateLoginScreen', type: WIDGET.UPDATE_LOGIN_SCREEN,
                },
            ],
        },
        datastore: {
            updateLoginScreen: {
                height,
                contactUsDetails,
                backAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                },
                proceedAction: {
                    type: ACTION.PROCEED,
                    payload: {},
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                },
                action: {
                    type: ACTION.VERIFY_OTP,
                    payload: {},
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                },
                otpAction: {
                    type: ACTION.RESEND_OTP,
                    payload: {},
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                },
                closeModal: {
                    type: ACTION.CLOSE_MODAL,
                    payload: {},
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                },
                handleCloseOtpModalAction: {
                    routeId: ROUTE.UPDATE_LOGIN_SCREEN,
                    type: ACTION.CLOSE_OTP_MODAL,
                    payload: {}
                },
            }
        },
    };
};
export const updateLoginScreenMf = {
    onLoad: async ({ getHeight }) => {
        const contactUsDetails = await getContactUsDetails();
        return Promise.resolve(template(getHeight(), contactUsDetails));
    },
    actions: {
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.PROCEED]: verifyNewNumber,
        [ACTION.VERIFY_OTP]: verifyOtp,
        [ACTION.RESEND_OTP]: resendOtp,
        [ACTION.CLOSE_MODAL]: closeModal,
        [ACTION.CLOSE_OTP_MODAL]: handleCloseOtpModal,
    },
};
